const env = {
    production: false,
    api: {
        host: 'https://api-retcercano-qa.ripley.com.pe/auth',
        x_api_key: '0oevDLNwix9aCfGR73BVF1E1DOxtAKqKaowG7Tkg',
    },
    recaptcha: {
        webKey: "6Ld0rjEaAAAAAJA0H81TzTlJjRL8JrOTxPeTs2ZN"
    }
  }
  
  export default env;